'use client';

import { styled } from '@linaria/react';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import Switch from './Switch';
import NavBar from './NavBar';
import { PopTopicTab } from '@fe-news/constants/pop-topic/type';
import PopTopicSearch from '@fe-news/components/molecules/PopTopicSearch/lazy';

const View = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding: 6px 0px;

  @media screen and (max-width: ${SCREEN_SIZE.TABLET}px) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

type PopTopicFilterProps = {
  tab: PopTopicTab;
  onClickTab: (tab: PopTopicTab) => void;
};

const PopTopicFilter: React.FC<PopTopicFilterProps> = ({ tab, onClickTab }) => {
  return (
    <div>
      <View>
        <Switch tab={tab} onClickTab={onClickTab} />
        {tab === PopTopicTab.PopTopic && <PopTopicSearch />}
      </View>
      <NavBar />
    </div>
  );
};

export default PopTopicFilter;
